import React, { Fragment } from "react";
import styled, { css } from "styled-components";

import { WorkspacePlanTier } from "common/interfaces";
import { t } from "js/i18n";
import Banner from "js/Components/Banner";
import ChangePlanDialog from "js/react/components/Dialogs/ChangePlanDialog";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import WorkspaceController from "js/controllers/WorkspaceController";

const LockedDimmedChildren = styled.div.attrs(() => ({ inert: "" }))`
    opacity: 0.5;
    caret-color: transparent;
`;

const BannerOverlay = styled.div`
    position: absolute;
    inset: 0;
    z-index: 10;
     ${({ $contentOffsetTop }) => !$contentOffsetTop && css`
        background: rgba(0, 0, 0, 0.5);
     `}
    display: flex;
    align-items: flex-start;
    justify-content: center;

`;

const BannerContainer = styled.div`
    width: 100%;
    pointer-events: none;
    padding: 20px;
`;

function UnlockAiGenerationBanner({ showOverlay = false, children, className }) {
    const isBasic = WorkspaceController.plan.tier === WorkspacePlanTier.BASIC;

    if (!isBasic) return children ?? null;

    const content = (<BannerContainer className={className}>
        <Banner
            headerText={t("Unlock AI generation")}
            bodyText={t("Upgrade to generate slides, rewrite text, and create stunning custom images with AI")}
            buttonLabel={t("Upgrade")}
            onButtonClick={() => ShowDialog(ChangePlanDialog, {
                featuredPlan: WorkspacePlanTier.PRO,
                analytics: { cta: "generate_with_ai" }
            })}
        />
    </BannerContainer>);

    if (children) {
        return (
            <>
                {content}
                <LockedDimmedChildren>
                    {children}
                </LockedDimmedChildren>
            </>
        );
    }

    if (!showOverlay) return content;

    return (
        <BannerOverlay>
            {content}
        </BannerOverlay>
    );
}

export default WorkspaceController.withInitializedState(UnlockAiGenerationBanner);
